import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



interface GoalScorerMarketPropsType {

    variant: DefaultComponentVariantType | null;

}



const setGoalScorerMarketWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            gap: ${theme.star.gap.small};

        `;

    }

    return css`

        &::after {

            border-bottom: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};

        }    

    `;

};



export const GoalScorerMarketWrapper = withConfig(theme => styled('div', { label: 'GoalScorerMarketWrapper' })<GoalScorerMarketPropsType>`

    ${({ variant }): SerializedStyles => setGoalScorerMarketWrapper(variant, theme)}

    display: flex;

    flex-flow: row nowrap;

    position: relative;

    &::after {

        content: '';

        left: 0;

        margin-top: -1px;

        position: absolute;

        top: 100%;

        width: 100%;

    }

`);



const setGoalScorerMarketListWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            gap: ${theme.star.gap.small};

        `;

    }

    return css`

        border-right: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};  

    `;

};



export const GoalScorerMarketListWrapper = withConfig(theme => styled('div', { label: 'GoalScorerMarketListWrapper' })<GoalScorerMarketPropsType>`

    ${({ variant }): SerializedStyles => setGoalScorerMarketListWrapper(variant, theme)}

    display: flex;

    flex-flow: column nowrap;

    flex: 1 1 100%;

    &:empty {

        display: none;

    }

`);



const setGoalScorerMarketListItem = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            background: ${theme.star.marketGroupGoalscorer.bgColorQuaternary};

            border-radius: ${theme.star.radius.medium};

            gap: ${theme.star.gap.small};

            padding: ${theme.star.padding.small};

        `;

    }

    return css``;

};



export const GoalScorerMarketListItem = withConfig(theme => styled('div', { label: 'GoalScorerMarketListItem' })<GoalScorerMarketPropsType>`

    ${({ variant }): SerializedStyles => setGoalScorerMarketListItem(variant, theme)}

    display: flex;

    flex-flow: row nowrap;

`);



const setMarketGroupCaptionDesktop = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            padding-top: ${theme.star.padding.small};

        `;

    }

    return css`

        border-bottom: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};

        padding-top: 1px;

    `;

};



export const MarketGroupCaptionDesktop = withConfig(theme => styled('div', { label: 'MarketGroupCaptionDesktop' })<GoalScorerMarketPropsType>`

    ${({ variant }): SerializedStyles => setMarketGroupCaptionDesktop(variant, theme)}

    align-items: center;

    display: flex;

    justify-content: space-between;

    line-height: 1.4;

    position: relative;

`);



interface CaptionDesktopPropsType {

    isFirst?: boolean;

    variant: DefaultComponentVariantType | null;

}



const setCaptionDesktop = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css``;

    }

    return css`

        border-right: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};

        border-left: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};

    `;

};



export const CaptionDesktop = withConfig(theme => styled('span', { label: 'CaptionDesktop' })<CaptionDesktopPropsType>`

    ${({ variant }): SerializedStyles => setCaptionDesktop(variant, theme)}

    margin-left: -1px;

    color: ${theme.star.marketGroupGoalscorer.txtColor};

    font-size: ${theme.star.fontSize.xSmall};

    text-align: ${({ isFirst }): string => isFirst === true ? 'left': 'center'};

    padding-left: ${({ isFirst }): string => isFirst === true ? '8px': '0'};

    width: ${({ isFirst }): string => isFirst === true ? '100%': '50px'};

    &:first-of-type {

        border-left: none;

    }

    &:last-of-type {

        &:not(:only-of-type) {

            border-right: none;

        }

    }

    @media ${theme.star.mediaQuery.tablet} {

        width: ${({ isFirst }): string => isFirst === true ? '100%': '68px'};

    }

`);





const setCaptionGroupDesktop = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            gap: ${theme.star.gap.small};

            margin-right: 4px;

        `;

    }

    return css``;

};



export const CaptionGroupDesktop = withConfig(theme => styled('div', { label: 'CaptionGroupDesktop' })<GoalScorerMarketPropsType>`

    ${({ variant }): SerializedStyles => setCaptionGroupDesktop(variant, theme)}

    display: flex;

`);



export const CaptionDesktopRab = withConfig(theme => styled(CaptionDesktop, { label: 'CaptionDesktopRab' })<CaptionDesktopPropsType>`

    width: ${({ isFirst }): string => isFirst === true ? '100%': '49px'};



    @media ${theme.star.mediaQuery.tablet} {

        width: ${({ isFirst }): string => isFirst === true ? '100%': '64px'};

    }

`);

